<template>
  <div class="navbar">
    <v-container>
      <div class="col-2-between">
        <div class="col-left">
          <nav>
            <Widget position="NavbarMenu"/>
          </nav>
        </div>
        <div class="col-right">
          <div class="auth-profile">
            <router-link to="/my-organization" v-if="isLoggedIn">{{ $t("Рабочий кабинет") }}</router-link>
          </div>
          <div class="login-logout">
            <router-link to="/login" v-if="!isLoggedIn">{{ $t("Войти") }}</router-link>
            <a href="#" @click.prevent="logout" v-if="isLoggedIn">{{ $t("Выйти") }}</a>
          </div>
          <Language />
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import Language from '@/components/app/Language'
import Widget from '@/components/app/Widget'

export default {
  components: {
    Widget,
    Language
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    }
  },
  methods: {
    async logout () {
      await this.$store.dispatch('logout')
      this.$router.push('/login')
    }
  }
}
</script>
